// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1hXrH","title":"Images90_title__3BaFH","images":"Images90_images__3Fevf"};